import LassoToggleButtons from '../../../components/LassoToggleButtons';
import { Stack } from '@mui/material';
import React, { Dispatch, SetStateAction, useRef } from 'react';
import { useGetCohortCompositionQuery } from '../../../api/dashboardApiSlice';
import { useSelector } from 'react-redux';
import { selectSelectedDatabase } from '../../common/databaseSlice';
import DataTable from './DataTable';
import PieChart from './PieChart';
import BarChart from './BarChart';

type Props = {
    view: string;
    setView: Dispatch<SetStateAction<"chart" | "table">>;
}

enum ChartType {
    PIE = 'PIE',
    BAR = 'BAR',
}

const CohortDemographics = ({ view, setView }: Props) => {
    const database = useSelector(selectSelectedDatabase);

    const { data } = useGetCohortCompositionQuery({ database });

    const tableChartViewportRef = useRef<HTMLDivElement>(null);

    const getBarChartList = () => {
        return Object.values(data || {})?.filter((chart: any) => chart.type === ChartType.BAR)
    }

    const getPieChartList = () => {
        return Object.values(data || {})?.filter((chart: any) => chart.type === ChartType.PIE)
    }

    const getList = () => {
        return Object.values(data || {});
    }

    const renderChart = (chart: any, index: number) => {
        if (view === "table") {
            return <DataTable
                key={index}
                selectedSessionFilter={undefined}
                title={chart?.title}
                rowData={chart?.data}
                columnDefs={[{
                    field: 'label',
                },
                { field: 'value' }]}/>
        }
        if (chart.type == ChartType.PIE) {
            return (
                <PieChart
                    key={index}
                    data={chart?.data}
                    title={chart?.title}
                    selectedSessionFilter={undefined}
                    ddAvailable={false}
                    imagingData={[]}
                />
            )
        } else if (chart.type == ChartType.BAR) {
            return (
                <BarChart
                    key={index}
                    data={chart?.data}
                    source={chart?.source}
                    title={chart?.title}
                    selectedSessionFilter={undefined}
                    ddAvailable={false}
                    imagingData={[]}
                    cohort={true}
                    sessionInfoMap={{}}
                />
            )
        }
        return <></>
    }

    return (
        <Stack height={"calc(100% - 60px)"} gap={3}>
            <Stack>
                <LassoToggleButtons
                    value={view}
                    onChange={(e, newValue) => {
                        if (newValue) {
                            setView(newValue)
                        }
                    }}
                    exclusive
                    buttons={[
                        { label: "Chart View", value: "chart", minWidth: '200px' },
                        { label: "Table View", value: "table", minWidth: '200px' }
                    ]}/>
            </Stack>

            {view === "table" ?
                <Stack
                    ref={tableChartViewportRef}
                    flexDirection="column"
                    overflow={"auto"}
                    width={"100%"}
                    paddingRight={3}
                >
                    <Stack>
                        {getList().map((item, index) => {
                            return renderChart(item, index);
                        })}
                    </Stack>
                </Stack>
                :
                <>
                    <Stack flexDirection={"row"} gap={3} overflow={"auto"} width={"100%"} paddingBottom={1}>
                        <Stack flexDirection="column" overflow={"auto"} minWidth={"950px"} width={"100%"}
                            paddingRight={3}>
                            {getBarChartList()?.map((chart, index) => {
                                return renderChart(chart, index);
                            })}
                        </Stack>
                        <Stack flexDirection="column" overflow={"auto"} minWidth={"450px"} paddingRight={3}>
                            {getPieChartList()?.map((chart, index) => {
                                return renderChart(chart, index);
                            })}
                        </Stack>
                    </Stack>
                </>
            }
        </Stack>
    )
}

export default CohortDemographics;
